const theme = {
  fontFamily: "CircularStd",
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    position: "fixed",
    width: "100%",
    left: 0,
    top: 0,
    flexWrap: "wrap",
    alignContent: "center",
  },
};

export default theme;
